module.exports = __webpack_public_path__ + "img/delete_icon.846eeb49.svg";